<script>

    import { toast } from 'bulma-toast'
    import { ticketStore, modalStore, notifyStore } from '../stores'
    
    import TicketsService from '../$services/tickets.service'
    import DateMethod from '../$methods/date.method'
    
    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import Textarea from '../$components/textarea.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import Subtitle from '../$components/subtitle.svelte'
    import Spinner from '../$components/spinner.svelte'

    let data = {
        status: $ticketStore.status,
        response: $ticketStore.response,
        history: $ticketStore.history
    }

    let loading = false

    async function updateTicket() {

        loading = true
        const resp = await TicketsService.updateTicket($ticketStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        ticketStore.set(resp.data)
        modalStore.set('ticket_modal')
        notifyStore.set('tickets_updated')
        toast({message: 'Ticket actualizado', type: 'is-success'})
    }

    function filterItem(historyIndex) {
        data.history = data.history.filter((item, index) => index != historyIndex)
    }

</script>

<Form on:submit={ updateTicket } {loading} >

    <Select bind:value={ data.status } 
        label="Estatus"
        options={[
            {value: 'revisión', text: 'Revisión'},
            {value: 'seguimiento', text: 'Seguimiento'},
            {value: 'finalizado', text: 'Finalizado'},
            {value: 'resuelto', text: 'Resuelto'}
        ]}
    />

    <Textarea bind:value={ data.response }
        label="Nuevo comentario"
    />

    {#if data.history && data.history}
        <Subtitle text="Historial" />
        <Spinner {loading} />
        {#if !loading}
            <ul class="ticket-history-list">
                {#each data.history as item, index}
                    <li class="ticket-history-entry is-light">
                        <div>{ item.response }</div>
                        <div class="ticket-history-meta">
                            <small class="has-text-grey">{ DateMethod.dateLarge(item.created) }</small>
                            <ButtonDelete on:confirm={() => filterItem(index)} { loading } />
                        </div>
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="ticket_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>

</Form>

